import React from 'react'

export const title = <>Legacy <span style={{color: 'var(--color-accent-2)'}}>Lucidworks</span> docs</>
export const description = <>Learn how to create Lucidworks driven apps and power insights into your products. This documentation will guide you to develop your core search experience. This site includes legacy documentation for product versions that are no longer supported, according to our <a href="https://doc.lucidworks.com/fusion/5.10/7shln5/lucidworks-version-support-lifecycle" target="_blank" rel="noopener noreferrer"><span className="underline">Lucidworks Fusion Product Lifecycle</span>.</a></>

// items used for home page "Lucidworks Solutions" section
export const solutionsItems = [
    {
        title: 'Commerce',
        link: '/fusion/5.11/461/smart-answers',
        description: 'Personalize and dynamically curate shopper experience',
        gradient: 'linear-gradient(60deg, #ED308B 0%, #FEB80B 100%)'
    },
    {
        title: 'Customer Service & Case Resolutions',
        link: '/fusion/5.11/hdpyf2/customer-dashboard',
        description: 'Connect agents and customers, personalize interactions',
        gradient: 'linear-gradient(60deg, #13C5BB 0%, #76C3ED 100%)'
    },
    {
        title: 'Knowledge Management',
        link: '/fusion/5.11/cx3sp3/curating-your-search-experience',
        description: 'Help employees be more informated and effective at their jobs',
        gradient: 'linear-gradient(60deg, #76C3ED 0%, #1F81CC 100%)'
    }
]

// items used for "What's New" home page section
export const whatsNewItems = [
    {
        title: 'Fusion 5.10.0',
        link: '/fusion/5.10/ce6szc/fusion-5-10-0?ref=homepage',
        description: 'Released on March 28, 2024, this release adds several new features and improvements.'
    },
    {
        title: 'Fusion 4',
        link: '/fusion-server/4.1/8764/fusion-server?ref=homepage',
        description: 'Develop core search experience. Explore Fusion Server, Fusion AI, and App Studio.'
    },
    {
        title: 'JDBC V2 connector v2.6.0',
        link: '/fusion-connectors/5.10/4/release-notes#february-20-2024-jdbc-v2-v2-6-0?ref=homepage',
        description: 'The JDBC V2 connector adds a new pagination feature. See the release notes for details.'
    }
]
